/**
 * Created by seaasun on 2018/2/9.
 */
/**
 * Created by seaasun on 2017/12/12.
 */

import NProgress from 'nprogress'
import map from './map.js'
import validate from './validate.js'
// import globalError from './globalError.js'
import moment from 'moment'

export default {
  delayTime: 3000, // Non-first screen API lazy loading time, millisecond
  post (url, data, success, error) {
    success = success || function () {}
    error = error || function () {}
    let ajax = new XMLHttpRequest()
    ajax.open('post', url)
    ajax.setRequestHeader('Content-type', 'application/json;charset=UTF-8')
    ajax.timeout = 4000
    ajax.onreadystatechange = function () {
      if (ajax.readyState === 4) {
        if (ajax.status === 504) {
          error(ajax.responseText)
          ajax.abort()
        } else if (ajax.status === 200) {
          success(ajax.responseText)
        } else {
          error(ajax.responseTex)
        }
        ajax = null
      }
    }
    ajax.send(JSON.stringify(data))
  },
  createMap (id, options) {
    this.maps[id] = map(id, options)
  },
  maps: {},
  numberFormat (num, symbol, decimal, rounding, isThousands) {
    /*
      num: number,
      symbol: default: '$'
      decimal: default: 2
      rounding: 'round', 'no',
      isThousands: default: true
     */
    if (symbol === undefined) symbol = '$'

    if (decimal === 0) {
    } else if (!decimal) {
      decimal = 2
    }

    rounding = rounding || 'round'
    isThousands = isThousands || true

    num = parseFloat(num)
    // rounding
    if (rounding === 'no') {
    } else if (rounding === 'round') {
      num = num.toFixed(decimal)
    }
    // Thousands
    num = num && num.toString()
      .replace(/(^|\s)\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
    // money symbol
    return symbol + num
  },
  dateFormat (date, format) {
    date = date || new Date()
    format = format || 'MMMM Do YYYY, hh:mm:ss'
    return moment(date).format(format)
  },
  vaildZip (code, type) {
    type = type || 'zip'
    //  ZipRegExp = new RegExp(page.placeorder.ZipRegularExpression, "i");
    if (type === 'zip') {
      return /^[0-9]{5}$/.test(code)
    } else if (type === 'zip4') {
      return /^[0-9]{9}$/.test(code)
    } else if (type === 'crrt') {
      return /^[0-9]{5}[:]{1}[A-Za-z]{1}[0-9]{3}$/.test(code)
    } else {
      return true
    }
  },
  progressStart () {
    NProgress.start()
  },
  progressDone () {
    NProgress.done()
  },
  sortJson (jsonObjects, sortBy, direction, convertTypeFun) {
    if (jsonObjects == null) {
      return
    }
    var intDirection = (direction === 'asc' ? 1 : -1)
    var fn = function (r1, r2) {
      var v1, v2
      var tmpArr = sortBy.split('.')
      v1 = r1[tmpArr[0]]
      v2 = r2[tmpArr[0]]
      for (let i = 1; i < tmpArr.length; i++) {
        v1 = v1[tmpArr[i]]
        v2 = v2[tmpArr[i]]
      }
      if (convertTypeFun != null && typeof (convertTypeFun) === 'function') {
        v1 = convertTypeFun(v1)
        v2 = convertTypeFun(v2)
      }
      var result = (v1 > v2) ? 1 : ((v1 < v2) ? -1 : 0)
      return intDirection * result
    }
    jsonObjects.sort(fn)
  },
  getUrlParam (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = window.location.search.substr(1).match(reg)
    if (r !== null) {
      return decodeURI(r[2])
    }
    return null
  },
  getRootPath () {
    return window.first.rootUrl()
  },
  validate,
  verify (val, rules) {
    return this.validate(val, rules, true).isError
  },
  log (type, name, message, info) {
    if (typeof (message) !== 'string') {
      message = JSON.stringify(message)
    }
    let data = {
      type: type || 'error',
      name: name || 'error',
      message: message,
      info: JSON.stringify(info) || '',
      url: '',
      referenceUrl: '',
      clientDate: (new Date()).toISOString()
    }

    this.post(this.getRootPath() + 'PlaceOrder.aspx/AddErrorLog', data)
    return data
  },
  uaEvent (category, action, label) {
    window.dataLayer.push({
      'event': 'uaEvent',
      'uaEventCategory': category,
      'uaEventAction': action,
      'uaEventLabel': label
    })
  },
  uaEcommerce (order, itemName, SKU) {
    let totalCharge = Math.round((order.TotalEstmCost) * 100) / 100
    let unitPrice = Math.round((totalCharge / order.TotalDesiredQty) * 100000) / 100000
    window.dataLayer.push({
      'event': 'uaEcommerce',
      'transactionId': order.OrderCode, // order.code
      'transactionAffiliation': 'SL360', // siteName
      'transactionTotal': totalCharge, // totalCharge
      'transactionTax': 0.00,
      'transactionShipping': order.ShippingCharge, // order.ShippingCharge
      'transactionProducts': [{
        'sku': SKU, // uc.success.FormatItemCode(order.ListType)
        'name': itemName, //  entity.lookup.DataSource.getByCode(order.ListType).DisplayName
        'category': 'Mailing Lists',
        'price': unitPrice,  // unitPrice
        'quantity': order.TotalDesiredQty // Quantites
      }]
    })
  },
  loadCss (url, cb) {
    let link = document.createElement('link')
    link.type = 'text/css'
    link.rel = 'stylesheet'
    link.href = url
    document.getElementsByTagName('head')[0].appendChild(link)
    if (typeof (cb) === 'function') {
      link.onload = function () {
        cb()
      }
    }
  },
  loadJs (url, cb) {
    let script = document.createElement('script')
    script.src = url
    script.type = 'text/javascript'
    document.getElementsByTagName('head')[0].appendChild(script)
    if (typeof (cb) === 'function') {
      script.onload = script.onreadystatechange = function () {
        if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
          cb()
          script.onload = script.onreadystatechange = null
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/utils/index.js